import { SvgIcon, SvgIconProps } from "@mui/material";

export function CalendarIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M19,4 L18,4 L18,2 L16,2 L16,4 L8,4 L8,2 L6,2 L6,4 L5,4 C3.89,4 3,4.9 3,6 L3,20 C3,21.1045695 3.8954305,22 5,22 L19,22 C20.1045695,22 21,21.1045695 21,20 L21,6 C21,4.8954305 20.1045695,4 19,4 M19,20 L5,20 L5,10 L19,10 L19,20 M19,8 L5,8 L5,6 L19,6 L19,8 M12,13 L17,13 L17,18 L12,18 L12,13 Z" />
    </SvgIcon>
  );
}
